import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { BrowserRouter as Router, Switch, Route, } from "react-router-dom";

import Sidebar from './sidebar'
import NewGrid from './grid3dispatch' 
import pageTasksDB from './pageTasks-database'
import ticketsDB from './tickets-database'
import initialLayouts from './initialLayouts'
import gridReducer from './gridReducer'
import LayoutsDispatch from './contextLayouts'
import initialInfo from './initialInfo'
import infoReducer from './infoReducer'
import StateInfo from './contextInfo'
import StateInfoDispatch from './contextInfoDispatch'

import Loading from './loading'
const PageTasks = lazy(() => import('./pageTasks'));
const PageClients = lazy(() => import('./pageClients'));
const PageTickets = lazy(() => import('./pageTickets'));
const PageAbout = lazy(() => import('./pageAbout'));


const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
      margin: 0;
      padding: 0;
      box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    font-size: 62.5%;
  }

  body {
    font-family: 'Poppins', sans-serif;
    color: #192A3E;
    font-weight: 300;
    line-height: 1.6;

    font-size: 1.6rem;

    background-color: #F5F6F8;
  }

  .react-draggable-dragging {
    z-index: 10;
  }


`;

const WrapperApp = styled.div`
  display: flex;
  flex-direction: column;
`
  const WrapperSidebarGrid = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  `
    const SidebarWrapper = styled.aside`
      min-height: 100vh;
      box-shadow: 4px 0 4px rgba(0, 0,0, .25);
      background-color: white;
    `

    const GridWrapper = styled.div`
      width: 100%;
      display: flex;
      justify-content: center;
    `
    const TasksWrapper = styled.div`
      width: 100%;
      display: flex;
      justify-content: center;
    `
    const ClientsWrapper = styled.div`
      width: 100%;
      display: flex;
      justify-content: center;
    `
    const LoadingWrapper = styled.div`
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
    `

const MemoSideBar = React.memo(Sidebar)
/* https://jsonstorage.net/api/items/402a9186-3494-4a2f-9b22-7007f445242e */
function App() {
  const [tickets, setTickets] = React.useState(ticketsDB)
  const [tasks, setTasks] = React.useState(pageTasksDB)

  const [gridState, gridDispatch] = React.useReducer(gridReducer, initialLayouts)

  const [infoState, infoDispatch] = React.useReducer(infoReducer, initialInfo)

  React.useEffect(() =>  {
    async function initialFetchClients () {
      const fetched = await fetch('https://api.jsonbin.io/b/5e6be8fb1337694aae2217a4', {  headers: { "secret-key": "$2b$10$tf1D9NTqNTDgEARqzbtpGepIKltugH7BNs4XaFl.0tesAEAjNp6ru"} } ) 
      const data = await fetched.json()
      infoDispatch({type: 'POPULATE_CLIENTS', payload: data})
    }
    initialFetchClients()
  }, [])

  return (
    <StateInfoDispatch.Provider value={infoDispatch}>
      <StateInfo.Provider value={infoState}>
        <LayoutsDispatch.Provider value={gridDispatch}>
        <Router>
          <WrapperApp>
            <GlobalStyle/>
            <WrapperSidebarGrid>
              <SidebarWrapper><MemoSideBar></MemoSideBar></SidebarWrapper>
              <Suspense fallback={<LoadingWrapper><Loading/></LoadingWrapper>}>
              <Switch>
                <Route path='/tasks'><TasksWrapper><PageTasks tasks={tasks} setTasks={setTasks}/></TasksWrapper></Route>
                <Route path='/clients'><ClientsWrapper><PageClients/></ClientsWrapper></Route>
                <Route path='/tickets'><ClientsWrapper><PageTickets setTickets={setTickets} tickets={tickets}/></ClientsWrapper></Route>
                <Route path='/about'><ClientsWrapper><PageAbout/></ClientsWrapper></Route>
                <Route path='/'><GridWrapper><NewGrid tasks={tasks} tickets={tickets} gridState={gridState}/></GridWrapper></Route>
              </Switch>
              </Suspense>
            </WrapperSidebarGrid>
          </WrapperApp>
        </Router>
        </LayoutsDispatch.Provider>
      </StateInfo.Provider>
    </StateInfoDispatch.Provider>
  );
}

export default App;